/*
 * @Author: your name
 * @Date: 2022-03-25 19:23:56
 * @LastEditTime: 2023-06-01 15:09:26
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\dash\BsyDashRadarChart\index.jsx
 */

import React from "react";

import BsyDashChartBase from '../BsyDashChartBase'
// import { BsyDashUtils } from '../../../utils/DashUtils';
// import {echarts} from '../../../plugins/echarts.js';
import BsySLoading from '../../BsySLoading';

import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashRadarChart extends BsyDashChartBase {


    constructor(props) {
        super(props)
        this.state = {
            ...this.state
        }
    }

    _initChartOption = (e, i, n, r) => {

        let _this = this
            , opt = _this.props;
        if (e) {
            i = [React.language("report.chart.legend", {
                val: "1"
            }), React.language("report.chart.legend", {
                val: "2"
            })]
            n = [React.language("report.chart.category", {
                val: "1"
            }), React.language("report.chart.category", {
                val: "2"
            }), React.language("report.chart.category", {
                val: "3"
            }), React.language("report.chart.category", {
                val: "4"
            }), React.language("report.chart.category", {
                val: "5"
            }), React.language("report.chart.category", {
                val: "6"
            })]
            r = [[15, 12, 9, 8, 11, 6], [13, 15, 19, 17, 4, 8]]
        }

        if (!r || r.length === 0) {
            this.setState({
                dataEmpty: true,
            })
            return;
        }
        this.setState({
            dataEmpty: false,
        }, () => {

            let categorys = JSON.parse(JSON.stringify(n)).reverse()
            let option = {};
            let option1 = this._renderOptions(option, i, n, r);
            if (this.myCharts) {
                this.myCharts.dispose();
                this.echartsRef.current.innerHTML = '';
            }
            this.myCharts = window.echarts.init(this.echartsRef.current);
            if (option1.onFinished) {
                this.myCharts.on('finished', function () {
                    option1.onFinished && option1.onFinished(_this.myCharts);
                });
            }
            this.myCharts.on('click', function (params) {
                let i = [];

                if (_this.xGroups && _this.xGroups[0]) {

                    let a = categorys[_this.indicatorIndex == 0 ? categorys.length - 1 : _this.indicatorIndex - 1];
                    let o = _this.nameMap[a] || a
                    let s = _this._dealLinkData(_this.xGroups[0], o);
                    s.field = _this.xGroups[0].name;

                    i.push(s)
                }

                if (_this.state.valueFields[0]) {
                    _this.linkParam = _this._getLinkFilterParams(i)
                    BsyUtils.applyFunc(_this, opt.onItemClick, [_this.linkParam], !1)
                }
            });
            this.myCharts.setOption(option1)
        })
    }


}